import React from 'react';
import { useNavigate } from 'react-router-dom';
import ParticlesBG from "../../Shared/ParticlesBG";
import { GeneralBox } from '../../Shared/GeneralBox';
import '../../Assets/Stylesheets/Pages/MarketingServices/Pr.scss';

// Import product data
import pressReleaseData from '../../SampleData/pressReleaseProducts.json';

export default function Pr() {
  const navigate = useNavigate();

  const handleProductClick = (productId) => {
    navigate(`/product/press-release/${productId}`);
  };

  // Get publications from JSON data
  const publications = pressReleaseData.products;

  return (
    <div id="pr-page">
      <section className="pr-header">
        <div className="particles circle-bg">
          <div className="container">
            <div className="title-box">
              <h1>
                <span className="color-font">PRESS RELEASES</span>
              </h1>
            </div>
          </div>

          <ParticlesBG />
          
          <div className="gradient-circle"></div>
          <div className="gradient-circle two"></div>
        </div>
      </section>
      
      <section className="services">
        <div className="container">
          <div className="pr-intro">
            <p>
              Get featured in leading publications to boost your brand's credibility and reach.
              <span className="highlight"> Companies featured in major publications see 300% increase in trust and credibility</span>,
              establishing authority and driving sustainable growth.
            </p>
          </div>
          <h2><span className="color-font">Publications</span></h2>
          
          {/* Product grid using GeneralBox */}
          <div className="box-column-container">
            {publications.slice(0, 3).map((pub) => {
              const logoSrc = require(`../../Assets/Images/${pub.logo}`);
              
              return (
                <div 
                  key={pub.id} 
                  className="box-column"
                  onClick={() => handleProductClick(pub.id)}
                >
                  <GeneralBox
                    title={pub.name}
                    link="#"
                    imageSrc={logoSrc}
                    description={pub.description}
                    customContent={
                      <div className="product-price-info">
                        <div className="price">${pub.price}</div>
                        <button className="view-details-button" onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleProductClick(pub.id);
                        }}>
                          View Details
                        </button>
                      </div>
                    }
                    className="homepage-box"
                    useGlow={true}
                  />
                </div>
              );
            })}
          </div>

          {/* Second row */}
          <div className="box-column-container second-row">
            {publications.slice(3, 6).map((pub) => {
              const logoSrc = require(`../../Assets/Images/${pub.logo}`);
              
              return (
                <div 
                  key={pub.id} 
                  className="box-column"
                  onClick={() => handleProductClick(pub.id)}
                >
                  <GeneralBox
                    title={pub.name}
                    link="#"
                    imageSrc={logoSrc}
                    description={pub.description}
                    customContent={
                      <div className="product-price-info">
                        <div className="price">${pub.price}</div>
                        <button className="view-details-button" onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleProductClick(pub.id);
                        }}>
                          View Details
                        </button>
                      </div>
                    }
                    className="homepage-box"
                    useGlow={true}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}